(() => {
  const init = (root = document) => root.querySelectorAll('[data-boot-shop]').forEach(shop => {
    if (shop.dataset.ready) return;
    shop.dataset.ready = 'true';
    const cards = [...shop.querySelectorAll('[data-product]')];
    const grid = shop.querySelector('[data-product-grid]');
    const width = shop.querySelector('[data-width]');
    const stock = shop.querySelector('[data-stock]');
    const sort = shop.querySelector('[data-sort]');
    const styles = [...shop.querySelectorAll('button[data-style]')];
    let selected = 'all';
    const apply = () => {
      let count = 0;
      styles.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.style === selected)));
      cards.forEach(c => {
        c.hidden = !(selected === 'all' || c.dataset.style.split(' ').includes(selected)) || !(width.value === 'all' || c.dataset.widths.includes(width.value)) || (stock.checked && c.dataset.stock !== 'true');
        if (!c.hidden) count++;
      });
      const sorted = [...cards].sort((a,b) => sort.value === 'price-low' ? +a.dataset.price - +b.dataset.price : sort.value === 'price-high' ? +b.dataset.price - +a.dataset.price : sort.value === 'title' ? a.dataset.title.localeCompare(b.dataset.title) : +a.dataset.order - +b.dataset.order);
      sorted.forEach(c => grid.appendChild(c));
      shop.querySelector('[data-result]').textContent = `${count} ${count === 1 ? 'product' : 'products'}${selected === 'all' ? '' : ' · ' + styles.find(b => b.dataset.style === selected).textContent}`;
      shop.querySelector('[data-empty]').hidden = count !== 0;
    };
    styles.forEach(b => b.addEventListener('click', () => { selected = b.dataset.style; apply(); }));
    [width, stock, sort].forEach(el => el.addEventListener('change', apply));
    shop.querySelectorAll('[data-reset]').forEach(b => b.addEventListener('click', () => { selected = 'all'; width.value = 'all'; stock.checked = false; sort.value = 'featured'; apply(); }));
    shop.querySelector('.au-boot-controls').hidden = false;
    apply();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
